import { styled, MenuItem, ListItemIcon, ListItemText } from "@mui/material";

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  color: theme.palette.common.black,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
}));

export const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.common.black,
  minWidth: "28px!important",
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  color: theme.palette.common.black,

  "& .MuiTypography-root": {
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
  },
}));
